module.exports = __webpack_public_path__ + "img/primary.22cb3354.svg";